module.exports = __webpack_public_path__ + "img/ipad-table.bab28e74.jpg";